import { QuoteCard } from '@/components/quotes/QuoteCard'
import type { PricedQuoteCard } from '@/components/quotes/quoteCardTypes'
import { cn } from '@/lib/utils'
import { STAGE_WIDTH } from './useStageScale'

/** The carousel's own card width, so the row is the product's card, not a lookalike. */
const CARD_WIDTH = 416
const CARD_GAP = 16

const noop = () => undefined

interface OpeningSceneProps {
  quotes: PricedQuoteCard[]
  /** The one card that lifts before opening — lifting both compared cards read as two openings. */
  armedIndex: number
  armed: boolean
}

/**
 * The scene the loop opens and closes on: six summary cards at their real width, scaled
 * down as one block so the row reads as a shelf of offers rather than six cards squeezed
 * into a column. Dissolves as a whole when a card is opened.
 */
export function OpeningScene({ quotes, armedIndex, armed }: OpeningSceneProps) {
  const width = quotes.length * CARD_WIDTH + (quotes.length - 1) * CARD_GAP
  const scale = STAGE_WIDTH / width

  return (
    <div
      className="absolute top-1/2 left-1/2 flex items-stretch"
      style={{
        width,
        gap: CARD_GAP,
        transform: `translate(-50%, -50%) scale(${scale})`,
      }}
    >
      {quotes.map((quote, index) => (
        <div
          key={quote.id}
          className={cn(
            'flex-1 rounded-xl transition duration-300 ease-out',
            armed && index === armedIndex && '-translate-y-4 scale-[1.03] shadow-2xl'
          )}
        >
          {/* onCardClick is what puts the card in its summary state; it is never clicked. */}
          <QuoteCard quote={quote} onCardClick={noop} />
        </div>
      ))}
    </div>
  )
}
